import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { isEqual } from 'lodash'

import { getJSONFromScript } from './lib/server_params'
import { isLive } from 'client/lib/deploy_env'
import { getCountry, getLanguage } from 'lib/locale'

import IntlMessageFormat from 'intl-messageformat'
import createFormatCache from 'intl-format-cache'

const getMessageFormat = createFormatCache(IntlMessageFormat)

const language = getLanguage()
const country = getCountry()

export function getI18nMessages() {
  return getJSONFromScript('messages')
}

function replacerWithCountThreshold(values, threshold, overflowValue) {
  return (match, word) => {
    return values[word] >= threshold ? overflowValue : values[word]
  }
}

function pluralizeMessage(messageContext, stringId, values) {
  const KEY_REGEXP = /\{(\w+)\}/g
  if (values) {
    let newStringId = stringId.replace(
      KEY_REGEXP,
      replacerWithCountThreshold(values, 3, 'other')
    )
    if (messageContext && messageContext[newStringId]) {
      return messageContext[newStringId]
    }

    newStringId = stringId.replace(
      KEY_REGEXP,
      replacerWithCountThreshold(values, 2, 'other')
    )
    if (messageContext && messageContext[newStringId]) {
      return messageContext[newStringId]
    }
  }
  return null
}

export const messages = getI18nMessages()

// do not attempt to translate these values to spans in development
// TODO fix the root cause so we don't need a blacklist
export const i18nBlacklist = [
  { contextId: 'components/share', stringId: 'link_placeholder' },
]

export function i18n(contextId, stringId, values) {
  const translation = i18nBase(...arguments)

  if (
    !isLive() &&
    typeof translation === 'string' &&
    !i18nBlacklist.find(item => {
      return isEqual(item, { contextId, stringId })
    })
  ) {
    const props = {
      'data-i18n-file': `locales/${country}/${language}/${contextId}`,
      'data-i18n-key': stringId,
      'data-i18n-values': JSON.stringify(values),
    }

    if (translation.includes('<')) {
      return ReactDOMServer.renderToStaticMarkup(
        <span {...props} dangerouslySetInnerHTML={{ __html: translation }} />
      )
    } else {
      return <span {...props}>{translation}</span>
    }
  } else {
    return translation
  }
}

function i18nBase(contextId, stringId, values) {
  if (contextId == null) {
    return messages
  } else if (stringId == null) {
    return messages[contextId]
  }

  let messageContext
  let message
  if (Array.isArray(contextId)) {
    messageContext = contextId.reduce((msgs, id) => {
      return { ...msgs, ...messages[id] }
    }, {})
  } else {
    messageContext = messages[contextId]
  }

  if (stringId.indexOf('.') >= 0) {
    message = messageContext
    stringId.split('.').forEach(part => {
      message = message && message[part]
    })
  } else {
    message = messageContext && messageContext[stringId]
  }
  if (!message) {
    const plmessage = pluralizeMessage(messageContext, stringId, values)
    if (plmessage) {
      message = plmessage
    } else {
      return ''
    }
  }

  for (let key in values) {
    if (values[key] != null) {
      values[key] = values[key].toString()
    }
  }

  return getMessageFormat(message).format(values)
}

export function getI18n(contextId) {
  return (stringId, values) => {
    return i18n(contextId, stringId, values)
  }
}

export function getI18nBase(contextId) {
  return (stringId, values) => {
    return i18nBase(contextId, stringId, values)
  }
}
